import { createTheme } from '@material-ui/core/styles';
import colors from './colors';
// import colors from './colors';

const theme = createTheme({
  palette: {
    primary: {
      light: '#625fe0',
      main: '#7753F8',
      dark: '#4742f3',
      contrastText: '#fff',
    },
    secondary: {
      light: '#625fe0',
      main: '#7753F8',
      dark: '#4742f3',
      contrastText: '#000',
    },
    white: {
      main: '#FFFFFF',
    },
  },
  button: {
    outline: 'none',
  },

  typography: {
    fontFamily: 'Urbanist',
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontSize: 14,
    body1: {
      fontSize: '0.9rem',
      fontWeight: 500,
    },
    button: {
      fontSize: '1rem',
      fontWeight: 500,
      textTransform: 'capitalize',
      boxShadow: 'none',
    },
  },
  overrides: {
    MuiContainer: {
      maxWidthLg: {
        maxWidth: '1600px !important',
      },
    },
    MuiBadge: {
      root: {
        colorPrimary: {
          backgroundColor: colors.primary,
        },
      },
    },
  },
});

export default theme;
